// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import FullPage from './components/common/FullPage';
import useHeaderHeightVar from './hooks/useHeaderHeightVar';
import ScrollToTop from './components/common/ScrollToTop';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './styles/GlobalStyle';
import { theme } from './styles/theme';

import Hero from './components/Hero';
import Header from './components/Header';
import CompanyPreview from './components/CompanyPreview';
import ProductsPreview from './components/ProductsPreview';
import NewsSection from './components/NewsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

import CEOMessage from './pages/About/CEOMessage';
import History from './pages/About/History';
import Certifications from './pages/About/Certifications';

import TrafficSafety from './pages/Products/TrafficSafety';
import Guardrail from './pages/Products/Guardrail';
import Signage from './pages/Products/Signage';
import Facilities from './pages/Products/Facilities';

import CarrierEmergencySign from './pages/Products/TrafficSafety/CarrierEmergencySign';
import SmartWarning from './pages/Products/TrafficSafety/SmartWarning';
import PyrotechnicSign from './pages/Products/TrafficSafety/PyrotechnicSign';
import SpeedCameraBooth from './pages/Products/TrafficSafety/SpeedCameraBooth';
import PanoramaLed from './pages/Products/TrafficSafety/PanoramaLed';
import Delinator from './pages/Products/TrafficSafety/Delinator';
import TubularMarker from './pages/Products/TrafficSafety/TubularMarker';
import WarningLight from './pages/Products/TrafficSafety/WarningLight';

import SafetyStairs from './pages/Products/Guardrail/SafetyStairs';
import LineNavigator from './pages/Products/Guardrail/LineNavigator';
import IoT from './pages/Products/Guardrail/IoT';
import HeightLimit from './pages/Products/Guardrail/HeightLimit';
import TunnelLimit from './pages/Products/Guardrail/TunnelLimit';
import Hipass from './pages/Products/Guardrail/Hipass';
import TunnelEntryLight from './pages/Products/Guardrail/TunnelEntryLight';
import Vms from './pages/Products/Guardrail/Vms'

import ShelterBus from './pages/Products/Facilities/ShelterBus';
import POP from './pages/Products/Facilities/POP';
import SleepShelter from './pages/Products/Facilities/SleepShelter';
import SoundProof from './pages/Products/Facilities/SoundProof';
import Banner from './pages/Products/Facilities/Banner';

import RoadSign from './pages/Products/Signage/RoadSign';
import GuideSign from './pages/Products/Signage/GuideSign';
import SolarFiberSign from './pages/Products/Signage/SolarFiberSign';
import SolarLedSign from './pages/Products/Signage/SolarLedSign';
import ExternalLightSign from './pages/Products/Signage/ExternalLightSign';
import SeagullSign from './pages/Products/Signage/SeagullSign';

import Governance from './pages/ESG/Esg';
import Report from './pages/ESG/Report';
import RealReport from './pages/ESG/Report/RealReport';
import AnonymousReport from './pages/ESG/Report/AnonymousReport';
import CheckReport from './pages/ESG/Report/CheckReport';
import ReportResult from './pages/ESG/Report/ReportResult';

import News from './pages/Community/News';
import Contact from './pages/Community/Contact';

import AdminLogin from './pages/Admin/Login';
import AdminDashboard from './pages/Admin/Dashboard';
import AdminGuard from './components/common/AdminGuard';
import NewsManager from './pages/Admin/NewsManager';
import AdminInquiries from './pages/Admin/AdminInquiries';




// 홈페이지 컴포넌트
function HomePage() {
  useHeaderHeightVar('#site-header');
  return (
    <>
      <GlobalStyle />
      <Hero />
      <CompanyPreview />
      <ProductsPreview />
      <NewsSection />
      <ContactSection />
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about/ceo" element={<CEOMessage />} />
          <Route path="/about/history" element={<History />} />
          <Route path="/about/certifications" element={<Certifications />} />

          <Route path="/products/traffic-safety" element={<TrafficSafety />} />
          <Route path="/products/guardrail" element={<Guardrail />} />
          <Route path="/products/signage" element={<Signage />} />
          <Route path="/products/facilities" element={<Facilities />} />  

          <Route path="/products/traffic-safety/carrier-emergency-sign" element={<CarrierEmergencySign />} />
          <Route path="/products/traffic-safety/smart-warning" element={<SmartWarning />} />
          <Route path="/products/traffic-safety/pyrotechnic-sign" element={<PyrotechnicSign />} />
          <Route path="/products/traffic-safety/speed-camera-booth" element={<SpeedCameraBooth />} />
          <Route path="/products/traffic-safety/panorama-led" element={<PanoramaLed />} />
          <Route path="/products/traffic-safety/delinator" element={<Delinator />} />
          <Route path="/products/traffic-safety/tubular-marker" element={<TubularMarker />} />
          <Route path="/products/traffic-safety/warning-light" element={<WarningLight />} />

          <Route path="/products/guardrail/safety-stairs" element={<SafetyStairs />} />
          <Route path="/products/guardrail/line-navigator" element={<LineNavigator />} />
          <Route path="/products/guardrail/IoT" element={<IoT />} />
          <Route path="/products/guardrail/height-limit" element={<HeightLimit />} />
          <Route path="/products/guardrail/tunnel-limit" element={<TunnelLimit />} />
          <Route path="/products/guardrail/hi-pass" element={<Hipass />} />
          <Route path="/products/guardrail/tunnel-entry-light" element={<TunnelEntryLight />} />
          <Route path="/products/guardrail/VMS" element={<Vms />} />

          <Route path="/products/facilities/shelter-bus" element={<ShelterBus />} />
          <Route path="/products/facilities/POP" element={<POP />} />
          <Route path="/products/facilities/sleep-shelter" element={<SleepShelter />} />
          <Route path="/products/facilities/sound-proof" element={<SoundProof />} />
          <Route path="/products/facilities/banner" element={<Banner />} />

          <Route path="/products/signage/road-sign" element={<RoadSign />} />
          <Route path="/products/signage/guide-sign" element={<GuideSign />} />
          <Route path="/products/signage/solar-fiber-sign" element={<SolarFiberSign />} />
          <Route path="/products/signage/solar-led-sign" element={<SolarLedSign />} />
          <Route path="/products/signage/external-light-sign" element={<ExternalLightSign />} />
          <Route path="/products/signage/seagull-sign" element={<SeagullSign />} />

          <Route path="/esg/esg" element={<Governance />} />
          <Route path="/esg/report" element={<Report />} />
          <Route path="/report/real" element={<RealReport />} />
          <Route path="/report/anonymous" element={<AnonymousReport />} />
          <Route path="/report/check" element={<CheckReport />} />
          <Route path="/report/result/:referenceId" element={<ReportResult />} />

          <Route path="/community/news" element={<News />} />
          <Route path="/community/contact" element={<Contact />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminGuard><AdminDashboard /></AdminGuard>}/>
          <Route path="/admin/news" element={<AdminGuard><NewsManager /></AdminGuard>}/>
          <Route path="/admin/inquiries" element={<AdminInquiries />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}



export default App;
